<template>
  <div>
    <h1>{{ $lang("報名表") }}</h1>
    <b-container class="dashed">
      <div>
        <template v-for="(item, index) in list">
          <add-items :item="item" :index="index" :ismember="index > 0" :isplayer="index === 0" :key="index"
            @click="handlerAdd(index)"></add-items>
        </template>
      </div>
      <div>
        <b-btn @click="cancle">{{ $lang("TEXT_RESET") }}</b-btn>
      </div>
      <!-- {{currentItem}} -->
      <div style="margin-bottom:20px;">
        <b-col md="6" class="px-0">
          <b-form-group horizontal :label-cols="4" :label="$lang('澳門手機號碼：')">
            <b-form-input ref="phone" type="text" v-model="tel" id="phone" name="phone" data-vv-as="phone"
              :class="errors.has('phone') && 'is-invalid'" v-validate="'required|mobile'"
              :placeholder="$lang('請輸入澳門手機號碼')" />
            <b-form-invalid-feedback :state="errors.has('phone')">
              {{ errors.first("phone") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-0">
          <b-form-group horizontal :label-cols="4" :label="$lang('確認手機號碼：')">
            <b-form-input ref="repasstel" type="text" v-model="confirmTel" name="repasstel" data-vv-as="repasstel"
              id="repasstel" :class="errors.has('repasstel') && 'is-invalid'" v-validate="'required|confirmed:phone'"
              :placeholder="$lang('請確認手機號碼')" />
            <b-form-invalid-feedback :state="errors.has('repasstel')">
              {{ errors.first("repasstel") }}
            </b-form-invalid-feedback>
            <div class="text-danger">{{ $lang('用作接收短訊通知') }}</div>
          </b-form-group>
        </b-col>
      </div>
      <b-form-group>
        <b-form-checkbox name="healthCheck2" v-model="agree" :class="errors.has('healthCheck2') && 'is-invalid'"
          v-validate="{ required: true }">
          <span class="lbl" style="color: red" v-html="$lang('TEXT_AGREE')"></span>
        </b-form-checkbox>
        <b-form-invalid-feedback :state="errors.has('healthCheck2')">
          {{ errors.first("healthCheck2") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-container>
    <b-modal ref="seleted" id="#selete" :title="title">
      <b-form-select v-model="currentItem">
        <option>{{ $lang("請選擇") }}</option>
        <option :value="item" v-for="(item, index) in members" :key="index" :disabled="item.disabled">
          {{ changeName(item) }}
        </option>
      </b-form-select>
      <div slot="modal-footer">
        <b-btn variant="success" @click="hideModel">{{
          $lang("BTN_YES")
        }}</b-btn>
        <b-btn variant="info" @click="clean">{{ $lang("清除") }}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
const list_empty = () => {
  return [
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
  ];
};
import AddItems from "@/components/AddItems";
import { $apis } from "@/helper";
export default {
  components: {
    AddItems,
  },
  created() { },
  methods: {
    // 获取报名表数据
    familyRecordDetail(id) {
      this.loading = true;
      $apis.family
        .familyRecordDetail({
          id: id,
        })
        .then((resp) => {
          let item = resp.data.record;
          this.filtersList(item.gamers).forEach((item, index) => {
            this.list.splice(index, 1, item);
          });
          // 判断是否是参赛者
          this.players = this.list.filter((item) => item.isMain);
          this.filtersMembers();
        })
        .catch((err) => { })
        .finally(() => {
          this.loading = false;
        });
    },
    getFamilyList() {
      this.loading = true;
      $apis.family
        .familyList()
        .then((resp) => {
          this.tel = resp.data.accountTel
          this.members = resp.data.members;
          this.filtersMembers();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openModel() {
      this.currentItem = {
        bornAt: "",
        firstName: "",
        gender: "",
        idNumber: "",
        isAdult: true,
        is_used: false,
        lastName: "",
        value: "",
      };
      this.$refs["seleted"].show();
    },
    hideModel() {
      this.$refs["seleted"].hide();
      this.changelist(this.currentIndex, this.currentItem);
      this.currentIndex = -1;
    },
    clean() {
      this.currentItem = {
        bornAt: "",
        firstName: "",
        gender: "",
        idNumber: "",
        isAdult: true,
        is_used: false,
        lastName: "",
        value: "",
      };
      this.hideModel();
    },
    changelist(index, currentItem) {
      let idNumber = currentItem.idNumber;
      this.list.splice(index, 1, {
        name: this.changeName(currentItem),
        idNumber: currentItem.idNumber,
        isAdult: currentItem.isAdult,
        bornAt: currentItem.bornAt,
        uuid: currentItem.uuid,
      });
      this.sign.splice(index, 1, idNumber);
      this.filtersMembers(index);
    },
    filtersMembers(indexs) {
      this.sign = this.list.map((item) => item.uuid);
      console.log(this.sign);
      this.members.forEach((item, index) => {
        var number = this.sign.toString().indexOf(item.uuid);
        this.players.forEach((player) => {
          if (item.uuid == player.uuid) {
            item.is_used = false;
          }
        });
        if (
          number != -1 ||
          (indexs == 0 && item.is10AgeLater) ||
          (indexs > 0 && !item.is10AgeLater) ||
          (item.is_used && this.currentIndex == 0)
        ) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    handlerAdd(index) {
      this.openModel();
      this.currentIndex = index;
      this.filtersMembers(index);
    },
    validateForm() {
      let flag = false;
      let number = 0;
      let adult = 0;
      let child = 0;
      let isplayers = this.list[0];
      let bornAt = isplayers && isplayers.bornAt;
      let year = new Date(bornAt).getFullYear();
      this.list.forEach((item) => {
        if (item.uuid) {
          number++;
          if (item.isAdult) {
            adult++;
          } else {
            child++;
          }
        }
      });
      if (number >= 3) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10020"));
        flag = false;
        return flag;
      }
      if (year >= 2016 && year <= 2024) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10018"));
        flag = false;
        return flag;
      }
      if (adult >= 1) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10027"));
        flag = false;
        return flag;
      }
      if (this.agree === true) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10051"));
        flag = false;
        return flag;
      }
      return flag;
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((res) => {
          if (res) {
            if (this.validateForm()) {
              var params = [];
              this.list.forEach((item) => {
                if (item.uuid) {
                  params.push(item.uuid);
                }
              });

              // 新增报名表数据
              $apis.family
                .newFamilyRecord({
                  ...params,
                  agree: this.agree,
                  tel: this.tel,
                })
                .then((resp) => {
                  if (resp.code === 0) {
                    localStorage.setItem("record-id", resp.data.id);
                    resolve(true);
                  }
                })
                .catch((err) => {
                  if (
                    err.data.message &&
                    typeof err.data.message === "string"
                  ) {
                    this.notification.error(this.$lang(err.data.message));
                  } else if (
                    err.data &&
                    Object.keys(err.data) instanceof Array
                  ) {
                    var that = this;
                    Object.keys(err.data).forEach(function (key) {
                      that.notification.error(
                        that.$lang(err.data[key].message)
                      );
                    });
                  } else {
                    this.notification.error(this.$lang(err.message));
                  }
                  reject(false);
                });
            } else {
              reject(false);
            }
          } else {
            reject(false);
          }
        });
      });
    },
    changeSubmit() {
      if (this.validateForm()) {
        var params = [];
        this.list.forEach((item) => {
          if (item.uuid) {
            params.push(item.uuid);
          }
        });
        return new Promise((resolve, reject) => {
          // // 修改报名表数据
          $apis.family
            .updateFamilyRecord({
              agree: this.agree,
              id: localStorage.getItem("record-id"),
              idNumbers: params,
            })
            .then((resp) => {
              this.notification.success(this.$lang("成功更新報名表"));
              resolve(true);
            })
            .catch((err) => {
              if (err.data.message && typeof err.data.message === "string") {
                this.notification.error(this.$lang(err.data.message));
              } else if (err.data && Object.keys(err.data) instanceof Array) {
                var that = this;
                Object.keys(err.data).forEach(function (key) {
                  that.notification.error(that.$lang(err.data[key].message));
                });
              } else {
                this.notification.error(this.$lang(err.message));
              }
              reject(false);
            });
        });
      }
    },
    cancle() {
      this.sign = [];
      this.filtersMembers();
      this.list = list_empty();
    },
    changeName(item) {
      let name;
      if (
        (item.firstName || item.lastNameOther) &&
        (item.lastName || item.firstNameOther)
      )
        name =
          (item.firstName || item.lastNameOther) +
          " " +
          (item.lastName || item.firstNameOther);
      else name = null;
      return name;
    },
    filtersList(list) {
      return list.map((item) => {
        return {
          name: this.changeName(item),
          isAdult: item.isAdult,
          idNumber: item.idNumber,
          bornAt: item.bornAt,
          isMain: item.isMain,
          uuid: item.uuid,
        };
      });
    },
  },
  computed: {
    title() {
      return this.currentIndex === 0
        ? this.$lang("選擇參賽兒童")
        : this.$lang("選擇參賽家庭成員");
    },
  },
  data() {
    return {
      agree: null,
      tel: "",
      confirmTel: "",
      id: null,
      text: "",
      sign: [],
      currentItem: [],
      currentIndex: -1,
      preView: false,
      members: [],
      players: [],
      cancleId: 0,
      recordsLength: 0,
      list: list_empty(),
    };
  },
  mounted() {
    this.getFamilyList();
  },
};
</script>
